import { useEffect, useState } from "react";
import { httprequest } from "../../data/api";
import { toast } from "react-toastify";
import useValidator from "../../hooks/useValidator";
import { Gender } from "../../utils/DropDown";
import useStyles from "./styles";
import { Grid } from "@mui/material";
import { Icon } from "@iconify/react";
import InputGroup from "../../components/FormComponent/InputGroup";
import Select from "react-select";
import Button from "../../components/Button";
import Modal from "../../components/Modal";
import SelectGroup from "../../components/FormComponent/SelectGroup";

const STUDENTS_ENDPOINT = "/api/v1/students";
const CREATE_GUARDIAN_ENDPOINT = "/api/v1/guardian";

const guardianmodal = ({ isOpen, onClose }) => {
  const classes = useStyles();
  const [multipleStudents, setMultipleStudents] = useState([]);
  const [guardianValidator, showCreateValidationMessage] = useValidator();
  const [isCreating, setIsCreating] = useState(false);
  const [copyModal, setCopyModal] = useState(false);
  const [generatePassword, setGeneratePassword] = useState(false);
  const [guardianArr, setGuardianArr] = useState([{
    first_name: "",
    last_name: "",
    email: "",
    gender: "",
    contact: "",
    address: "",
    type: "primary"
  }]);
  const [guardianForm, setGuardianForm] = useState({
    wards: multipleStudents, guardians: guardianArr
  });
  const [createdGuardianCredentials, setCreatedGuardianCredentials] = useState({
    email: "",
    password: ""
  });

  /**
 * Handles input changes for a guardian at a specific index.
 *
 * @function handleChange
 * @param {Event} e - The change event triggered from the input.
 * @param {number} index - Index of the guardian being updated.
 */
  const handleChange = (e, index) => {
    const { value, name } = e.target;
    const allGuardian = [...guardianArr];
    allGuardian[index][name] = value;
    setGuardianArr(allGuardian);
    setGuardianForm({ ...guardianForm, guardians: allGuardian });
  };

  const handleCopyModal = () => {
    setCopyModal(!copyModal);
  };

  /**
 * Fetches all students and maps them to select dropdown options.
 *
 * @function getAllStudents
 */

  const getAllStudents = () => {
    httprequest.get(STUDENTS_ENDPOINT).then((res) => {
      setMultipleStudents(res?.data?.data?.map((student) => {
        return {
          label: `${student?.student?.first_name} ${student?.student?.last_name}`,
          value: student?.student?.id
        };
      }));
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  /**
 * Adds a new additional guardian with default values to the form.
 *
 * @function AddAdditionalGuardian
 */

  const AddAdditionalGuardian = () => {
    const newGuardian = {
      first_name: "",
      last_name: "",
      email: "",
      gender: "",
      contact: "",
      address: "",
      type: "secondary"
    };
    setGuardianArr([...guardianArr, newGuardian]);
    setGuardianForm({ ...guardianForm, guardians: [...guardianArr, newGuardian] });
  };

  /**
 * Validates and submits the guardian form to create a new guardian.
 *
 * @function handleCreateGuardian
 */
  const handleCreateGuardian = () => {
    if (guardianValidator.allValid()) {
      setIsCreating(true);
      const formData = {
        ...guardianForm,
        generate_password: generatePassword
      };
      httprequest.post(CREATE_GUARDIAN_ENDPOINT, formData).then((res) => {
        setIsCreating(false);
        toast.success("Guardian Created and Invite sent successfully");
        if (generatePassword && res.data?.passwords?.length > 0) {
          const passwordData = res.data.passwords[0];
          setCreatedGuardianCredentials({
            email: passwordData.email,
            password: passwordData.password
          });
          setCopyModal(true);
        }
      }).catch((err) => {
        setIsCreating(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showCreateValidationMessage(true);
    }
  };

  /**
 * Removes a guardian from the form by index.
 *
 * @function handleDeleteGuardianItem
 * @param {Event} e - The click event.
 * @param {number} index - The index of the guardian to remove.
 */
  const handleDeleteGuardianItem = (e, index) => {
    e.preventDefault();
    const newGuardian = guardianArr.filter((item) => {
      return index !== guardianArr.indexOf(item);
    });

    setGuardianArr(newGuardian);
    setGuardianForm({ ...guardianForm, guardians: newGuardian });
  };

  /**
 * Handles setting a guardian as primary or secondary.
 *
 * @function handleIsType
 * @param {Event} e - The change event triggered from the checkbox.
 * @param {number} index - Index of the guardian being updated.
 */
  const handleIsType = (e, index) => {
    const { name, checked } = e.target;
    const allGuardian = [...guardianArr];
    const value = checked && "primary";

    // loop through all the array and set types to secondary
    allGuardian[index][name] = value;
    const updatedGuardian = allGuardian.map((obj, ind) => {
      if (ind !== index) {
        return { ...obj, type: "secondary" };
      }

      return obj;
    });

    setGuardianForm({ ...guardianForm, guardians: updatedGuardian });
  };

  /**
 * Handles changes in the ward multi-select dropdown.
 *
 * @function handleMultipleWardChange
 * @param {Array} event - Selected ward options.
 */
  const handleMultipleWardChange = (event) => {
    const selectedValue = event.map((item) => item.value);

    setGuardianForm({ ...guardianForm, wards: selectedValue });
  };

  useEffect(() => {
    getAllStudents();
  }, []);

  return (
    <div>
      {/* Create a Guardian Modal */}
      <Modal
        title="Create Guardian"
        subtitle={
          <div>Create Guardian
          </div>}
        modalContent={
          <>
            <div>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <div className="multiple-select">
                  <p>Wards / Children<span className="input-required">*</span> </p>
                  <Select isMulti name="wards"
                    closeMenuOnSelect={true} options={multipleStudents} onChange={handleMultipleWardChange}
                  />
                </div>
                {guardianValidator.message(
                  "wards",
                  guardianForm.wards,
                  "required"
                )}
              </Grid>
              {guardianArr?.map((item, i) => {
                return (
                  <Grid container spacing={2} className="input-padding" key={i}>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <InputGroup
                        label="Guardian First Name"
                        margin="normal"
                        inputType="text"
                        required
                        inputName="first_name"
                        value={item.first_name}
                        onChange={(e) => {
                          handleChange(e, i);
                        }}
                      />
                      {guardianValidator.message(
                        "first_name",
                        guardianArr[i]["first_name"],
                        "required"
                      )}
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <InputGroup
                        label="Guardian Last Name"
                        margin="normal"
                        required
                        inputType="text"
                        inputName="last_name"
                        value={item.last_name}
                        onChange={(e) => {
                          handleChange(e, i);
                        }}
                      />
                      {guardianValidator.message(
                        "last_name",
                        guardianArr[i]["last_name"],
                        "required"
                      )}
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <SelectGroup required label="Gender" children={
                        <select name="gender" onChange={(e) => handleChange(e, i)}>
                          <option value="">--- Select Gender ---</option>
                          {Gender?.map((label) => {
                            return (
                              <option key={label.key}>{label.text}</option>
                            );
                          })}
                        </select>
                      }
                      />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <InputGroup
                        label="Email"
                        margin="normal"
                        inputType="email"
                        inputName="email"
                        required
                        value={item.email}
                        onChange={(e) => {
                          handleChange(e, i);
                        }}
                      />
                      {guardianValidator.message(
                        "email",
                        guardianArr[i]["email"],
                        "required|email"
                      )}
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <InputGroup
                        label="Contact"
                        margin="normal"
                        required
                        placeHolder="Enter contact info"
                        inputType="tel"
                        inputName="contact"
                        value={item.contact}
                        onChange={(e) => {
                          handleChange(e, i);
                        }}
                      />
                      {guardianValidator.message(
                        "contact",
                        guardianArr[i]["contact"],
                        "required"
                      )}
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <InputGroup
                        label="Guardian Address"
                        margin="normal"
                        required
                        placeHolder="Enter Address"
                        inputType="address"
                        inputName="address"
                        value={item.address}
                        onChange={(e) => {
                          handleChange(e, i);
                        }}
                      />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div className={classes.check}>
                        <input
                          type="checkbox"
                          checked={generatePassword}
                          onChange={(e) => setGeneratePassword(e.target.checked)}
                        />
                        <label className="checkbox-label" htmlFor="">
      Generate password
                        </label>
                      </div>

                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <>
                        <input type="radio" name="type" defaultChecked={item?.type === "primary"} id="type" onChange={(e) => {
                          handleIsType(e, i);
                        }}
                        />
                        <label className="checkbox-label" htmlFor="current_term">Primary Guardian</label>
                      </>
                      {guardianValidator.message(
                        "Type",
                        guardianArr[i]["type"],
                        "required"
                      )}
                    </Grid>
                    {guardianArr?.length > 1 && (
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <div className={`${classes.remove} flex align-items-center`} onClick={(e) => handleDeleteGuardianItem(e, i)}>
                          <Icon icon="zondicons:minus-solid" width="16" height="16" />
                          <p>Remove this Guardian</p>
                        </div>
                      </Grid>
                    )}
                  </Grid>
                );
              })}
              {guardianArr?.length < 2 && (
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <div className={`${classes.addextra} flex align-items-center`} onClick={AddAdditionalGuardian}>
                    <Icon icon="octicon:feed-plus-16" width="16" height="16" />
                    <p>Add Secondary Guardian</p>
                  </div>
                </Grid>
              )}
            </div>
          </>
        }
        modalFooter={
          <>
            <div className={classes.modalFooterBtn}>
              <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Create Guardian" onClick={handleCreateGuardian} isLoading={isCreating} />
            </div>
          </>
        }
        isopen={isOpen}
        closeModal={onClose}
      />

      <Modal
        title="Guardian Successfully Created"
        subtitle="Please send to the immediately because you wont be able to see this password again"
        modalContent={
          <div className={classes.copy}>
            <Grid container spacing={2} className={classes.copy_div}>
              <Grid item lg={6} md={6} sm={12} xs={12}
                className={classes.details}
              >
                <span className={classes.details_span}>Email Address</span>
                <p className={classes.details_p}>{createdGuardianCredentials.email || "Not available"}</p>
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}
                className={classes.details}
              >
                <span className={classes.details_span}>Password</span>
                <p className={classes.details_p}>{createdGuardianCredentials.password || "Not available"}</p>
              </Grid>
            </Grid>

            <div className={classes.note}> <Icon icon="fluent:info-16-regular" width="16" height="16" />NB: Copy and send right away, you wont be able to send it after now</div>
          </div>
        }
        modalFooter={
          <>
            <Button variant="primary" buttonName="Copy" buttonSize="full" color="btndefault" onClick={() => {
              navigator.clipboard.writeText(
                `Email: ${createdGuardianCredentials.email}\nPassword: ${createdGuardianCredentials.password}`
              );
              toast.success("Copied to clipboard!");
            }}
            />
          </>
        }
        isopen={copyModal}
        closeModal={handleCopyModal}
      />
    </div>
  );
};

export default guardianmodal;
